import { default as _91id_93PtMcWQxES6Meta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/athlete/[id].vue?macro=true";
import { default as forgot_45password9rWr15GkDsMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/auth/forgot-password.vue?macro=true";
import { default as indexHz3gvnE83vMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/auth/index.vue?macro=true";
import { default as registrationocaI5Y94ytMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/auth/registration.vue?macro=true";
import { default as reset_45password3vU2fdqdXzMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/auth/reset-password.vue?macro=true";
import { default as verify_45emailSdgTj6nr5RMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/auth/verify-email.vue?macro=true";
import { default as callbackGXn8hA2b0GMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/auth/vk/callback.vue?macro=true";
import { default as _91slug_93Ko9G3rmBrpMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/camps/[slug].vue?macro=true";
import { default as _91slug_93HwN9VsxuGbMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/competitions/[slug].vue?macro=true";
import { default as indexdzB6AFKmQ0Meta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/competitions/index.vue?macro=true";
import { default as _91slug_93J8C7FpBaLWMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/events/[slug].vue?macro=true";
import { default as indexh37xp5721iMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/events/index.vue?macro=true";
import { default as indexXjEgPlkSnTMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/index.vue?macro=true";
import { default as _91slug_931X8i1INHSjMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/master-classes/[slug].vue?macro=true";
import { default as _91slug_93V0n3zG3wrrMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/media/[slug].vue?macro=true";
import { default as indexJmtWKgrz6UMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/media/index.vue?macro=true";
import { default as _91slug_93R17u7ojnjMMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/news/[slug].vue?macro=true";
import { default as _91slug_93ByR9rVY2t3Meta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/news/category/[slug].vue?macro=true";
import { default as index9xmjUfMDuDMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/news/index.vue?macro=true";
import { default as _91id_93AHUaOVI7CYMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-camp/[id].vue?macro=true";
import { default as createUn0LRaCC8GMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-camp/create.vue?macro=true";
import { default as update_45_91id_93uSATFafHaeMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-camp/update-[id].vue?macro=true";
import { default as index61F1CHC7t9Meta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-event/[id]/index.vue?macro=true";
import { default as updateZQaQJEPH84Meta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-event/[id]/update.vue?macro=true";
import { default as createAHfrw2AB2iMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-event/create.vue?macro=true";
import { default as _91id_93TvENv0jRlLMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-master-class/[id].vue?macro=true";
import { default as createXqsWUgQ6QJMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-master-class/create.vue?macro=true";
import { default as update_45idZfrxFxVK0dMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-master-class/update-id.vue?macro=true";
import { default as _91slug_93tNahVy8jklMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/p/[slug].vue?macro=true";
import { default as album_45_91id_93z5ibtH0BRjMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/photobank/album-[id].vue?macro=true";
import { default as checkoutvlc1APviifMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/photobank/checkout.vue?macro=true";
import { default as indext2fIDg9ZOgMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/photobank/index.vue?macro=true";
import { default as order_45idR7AtwE1AvJMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/photobank/order-id.vue?macro=true";
import { default as searchb8NVyxDCLhMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/photobank/search.vue?macro=true";
import { default as _91id_93VOpSJq4IhsMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/profile/extra-service/[id].vue?macro=true";
import { default as _91id_93ULAvCjZmeeMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/profile/extra-service/order/[id].vue?macro=true";
import { default as indexWPdEXMJUYDMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/profile/index.vue?macro=true";
import { default as ratingFCnmVjncFfMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/rating.vue?macro=true";
import { default as recordsPWxX0wBTQmMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/records.vue?macro=true";
import { default as results5EtSZw04EjMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/results.vue?macro=true";
import { default as _91slug_93shAYo59UzhMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/shop/[slug].vue?macro=true";
import { default as checkoutNECxKugVP5Meta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/shop/checkout.vue?macro=true";
import { default as homeeWHYIAZo1EMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/shop/home.vue?macro=true";
import { default as indexkBlkPDBXUbMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/shop/index.vue?macro=true";
import { default as _91id_93gwnL0n9jhDMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/shop/order/[id].vue?macro=true";
import { default as tournamentsNfvdQJNFErMeta } from "/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/tournaments.vue?macro=true";
export default [
  {
    name: "athlete",
    path: "/athlete/:id()",
    meta: _91id_93PtMcWQxES6Meta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/athlete/[id].vue")
  },
  {
    name: "forgot_password",
    path: "/auth/forgot-password",
    meta: forgot_45password9rWr15GkDsMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/auth/forgot-password.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexHz3gvnE83vMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/auth/index.vue")
  },
  {
    name: "registration",
    path: "/auth/registration",
    meta: registrationocaI5Y94ytMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/auth/registration.vue")
  },
  {
    name: "reset_password",
    path: "/auth/reset-password",
    meta: reset_45password3vU2fdqdXzMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/auth/reset-password.vue")
  },
  {
    name: "auth-verify-email",
    path: "/auth/verify-email",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/auth/verify-email.vue")
  },
  {
    name: "auth_vk_callback",
    path: "/auth/vk/callback",
    meta: callbackGXn8hA2b0GMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/auth/vk/callback.vue")
  },
  {
    name: "camp",
    path: "/camps/:slug()",
    meta: _91slug_93Ko9G3rmBrpMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/camps/[slug].vue")
  },
  {
    name: "competition",
    path: "/competitions/:slug()",
    meta: _91slug_93HwN9VsxuGbMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/competitions/[slug].vue")
  },
  {
    name: "competitions",
    path: "/competitions",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/competitions/index.vue")
  },
  {
    name: "event",
    path: "/events/:slug()",
    meta: _91slug_93J8C7FpBaLWMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/events/[slug].vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/events/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/index.vue")
  },
  {
    name: "master_class",
    path: "/master-classes/:slug()",
    meta: _91slug_931X8i1INHSjMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/master-classes/[slug].vue")
  },
  {
    name: "media_single",
    path: "/media/:slug()",
    meta: _91slug_93V0n3zG3wrrMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/media/[slug].vue")
  },
  {
    name: "media",
    path: "/media",
    meta: indexJmtWKgrz6UMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/media/index.vue")
  },
  {
    name: "post",
    path: "/news/:slug()",
    meta: _91slug_93R17u7ojnjMMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/news/[slug].vue")
  },
  {
    name: "post_category",
    path: "/news/category/:slug()",
    meta: _91slug_93ByR9rVY2t3Meta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/news/category/[slug].vue")
  },
  {
    name: "news",
    path: "/news",
    meta: index9xmjUfMDuDMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/news/index.vue")
  },
  {
    name: "order-camp-id",
    path: "/order-camp/:id()",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-camp/[id].vue")
  },
  {
    name: "order-camp-create",
    path: "/order-camp/create",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-camp/create.vue")
  },
  {
    name: "order-camp-update-id",
    path: "/order-camp/update-:id()",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-camp/update-[id].vue")
  },
  {
    name: "order_event",
    path: "/order-event/:id()",
    meta: index61F1CHC7t9Meta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-event/[id]/index.vue")
  },
  {
    name: "order_event_update",
    path: "/order-event/:id()/update",
    meta: updateZQaQJEPH84Meta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-event/[id]/update.vue")
  },
  {
    name: "order_event_create",
    path: "/order-event/create",
    meta: createAHfrw2AB2iMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-event/create.vue")
  },
  {
    name: "order_master_class",
    path: "/order-master-class/:id()",
    meta: _91id_93TvENv0jRlLMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-master-class/[id].vue")
  },
  {
    name: "order_master_class_create",
    path: "/order-master-class/create",
    meta: createXqsWUgQ6QJMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-master-class/create.vue")
  },
  {
    name: "order_master_class_update",
    path: "/order-master-class/update-id",
    meta: update_45idZfrxFxVK0dMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/order-master-class/update-id.vue")
  },
  {
    name: "page",
    path: "/p/:slug()",
    meta: _91slug_93tNahVy8jklMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/p/[slug].vue")
  },
  {
    name: "photobank-album-id",
    path: "/photobank/album-:id()",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/photobank/album-[id].vue")
  },
  {
    name: "photobank-checkout",
    path: "/photobank/checkout",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/photobank/checkout.vue")
  },
  {
    name: "photobank",
    path: "/photobank",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/photobank/index.vue")
  },
  {
    name: "photobank-order-id",
    path: "/photobank/order-id",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/photobank/order-id.vue")
  },
  {
    name: "photobank-search",
    path: "/photobank/search",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/photobank/search.vue")
  },
  {
    name: "profile_extra_service",
    path: "/profile/extra-service/:id()",
    meta: _91id_93VOpSJq4IhsMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/profile/extra-service/[id].vue")
  },
  {
    name: "extra_order",
    path: "/profile/extra-service/order/:id()",
    meta: _91id_93ULAvCjZmeeMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/profile/extra-service/order/[id].vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexWPdEXMJUYDMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/profile/index.vue")
  },
  {
    name: "rating",
    path: "/rating",
    meta: ratingFCnmVjncFfMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/rating.vue")
  },
  {
    name: "records",
    path: "/records",
    meta: recordsPWxX0wBTQmMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/records.vue")
  },
  {
    name: "results",
    path: "/results",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/results.vue")
  },
  {
    name: "shop_product",
    path: "/shop/:slug()",
    meta: _91slug_93shAYo59UzhMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/shop/[slug].vue")
  },
  {
    name: "shop_checkout",
    path: "/shop/checkout",
    meta: checkoutNECxKugVP5Meta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/shop/checkout.vue")
  },
  {
    name: "shop-home",
    path: "/shop/home",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/shop/home.vue")
  },
  {
    name: "shop",
    path: "/shop",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/shop/index.vue")
  },
  {
    name: "shop_order",
    path: "/shop/order/:id()",
    meta: _91id_93gwnL0n9jhDMeta || {},
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/shop/order/[id].vue")
  },
  {
    name: "tournaments",
    path: "/tournaments",
    component: () => import("/home/runner/work/front_swim4you_v3/front_swim4you_v3/pages/tournaments.vue")
  }
]